import {
    DEFAULT_SIGNALS_REST_API_STATUS,
    useSignalsRestApiConfiguredQuery,
} from "app/pages/sales-intelligence/modules/signals-rest-api/query/useSignalsRestApiConfiguredQuery";
export interface ISignalsRestApiData {
    isFetching: boolean;
    isStale: boolean;
    isConfigured: boolean;
    signalsCount: number;
}

const useSignalsRestApiData = (): ISignalsRestApiData => {
    const { data = DEFAULT_SIGNALS_REST_API_STATUS, isFetching, isStale } = useSignalsRestApiConfiguredQuery();

    return {
        isFetching,
        isStale,
        isConfigured: data.isConfigured,
        signalsCount: data.signalsCount,
    };
};

export default useSignalsRestApiData;
